$(() => {
  const $profileSelectionDropdown = $('select#profile_selection_dropdown');

  if ($profileSelectionDropdown.length > 0) {
    $('a.select-share-link').on('click', (e) => {
      const profileID = $profileSelectionDropdown.val();

      let url = new URL(e.target.getAttribute('href'), window.location.origin);
      let params = new URLSearchParams(url.search);

      params.set('profile_id', profileID);

      url.search = params.toString();
      e.target.setAttribute('href', url.toString());
    });
  }

  const $createProfileModal = $('#create-profile-modal');

  if ($createProfileModal.length > 0) {
    $createProfileModal.on('show.bs.modal', function(e) {
      const fundId = $(e.relatedTarget).data('fund-id');

      $('.new-profile-link', $createProfileModal).each((_, link) => {
        let url = new URL(link.getAttribute('href'), window.location.origin);
        let params = new URLSearchParams(url.search.slice(1));

        params.set('fund_id', fundId);

        url.search = params.toString();
        link.setAttribute('href', url.toString());
      });
    });
  }
});
